<template>
	<div>
        <modalTheme ref="modalTheme" v-model="dialog" :propAdd='paramProp' :val = 'val' @action="simpan"/>
        <modalconfirm ref="modalconfirmTheme" @action="deleteData"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Konfigurasi List Produk Web Referral</div>
		</div>
		<div v-if="loading">
			<!-- <loading-card></loading-card> -->
		</div>
		<div>
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<v-btn light depressed class="primary" @click="() => {dialog=true; paramProp='tambah'; val= {};}">
                            <v-icon>mdi-plus-circle</v-icon>
                            <div class="pl-2 text-capitalize">Tambah Theme</div>
                        </v-btn>
						<v-spacer></v-spacer>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				
			</v-slide-y-transition>
			<v-card outlined class="mt-3">
				<v-data-table loading :headers="headers" :items="webReferralThemeResults" hide-default-footer :options.sync="option" :server-items-length="webReferralThemePagination.total_data" disable-pagination>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
                                    <v-icon dark>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="hapus(item.web_referral_theme_id, item.web_referral_theme_name)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
                                    <v-icon dark>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Hapus</span>
                        </v-tooltip>
                    </template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!webReferralThemePagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div class="pt-5">
				<v-row v-if="webReferralThemePagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="webReferralThemePagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalTheme from '@/views/MLwarehouse/webReferral/modalTheme'
import { mapActions,  mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
        modalTheme
	},
	data() {
		return {
			menu: false,
			loading: true,
			dropfilter: false,
			sortBy: 'web_referral_theme_id',
			sortDir: 'DESC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '50', '100' ],
			headers: [
			{ text: 'Nama Theme', value: 'web_referral_theme_name', sortable: true },
			{ text: 'Jumlah Section', value: 'web_referral_theme_section_total', sortable: true, align: 'center'},
			{ text: 'Aksi', value: 'action', sortable: false},
			],
			filterData: [
			],
			params:[],
			paramProp: '',
			val: {},
			dialog: false,
			dialogConfirm: false,
		}
	},
	computed: {
		...mapState('webReferral', ['webReferralThemeResults', 'webReferralThemePagination', 'response']),
	},
	methods: {
		...mapActions('webReferral', ['getDataTheme', 'deleteTheme']),
		...mapMutations('webReferral', ['listWebReferralTheme']),
        ...mapMutations(['setOverlay']),

		async getData() {
			await this.getDataTheme(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
        hapus(id, name){
			this.propDelete = id
			let msg = `Yakin ingin menghapus ${name}`
			this.$refs.modalconfirmTheme.setMessage(msg)
			this.$refs.modalconfirmTheme.showConfirm()
		},
        async deleteData () {
			await this.setOverlay(true)
			await this.$refs.modalconfirmTheme.hideConfirm()
			await this.deleteTheme({id: this.propDelete}).then( () => {
				if(this.response.code == 200) {
					this.getData()
				}
			})
			await this.setOverlay(false)
		},
		ubah(item) {
			this.val = item;
			this.dialog = true;
			this.paramProp = 'edit'
		},
		reset() {
			this.val = {}
			this.konfirmasiSukses('')
			this.paramProp = '';
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Data Konfigurasi List Produk Web Referral`)
		this.getData()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
</style>